import { useI18n } from './I18nProvider'

/**
 * Hook to get translation function
 * Usage: const { t } = useTranslation()
 *        t('login.form.emailLabel')
 */
export function useTranslation() {
  const { t, language, setLanguage, translations } = useI18n()
  return { t, language, setLanguage, translations }
}

